<template>
  <div>
    <div class="wrap-document">
      <div class="page">
        <div class="top">
          <img src="@/assets/iconImage/bagi.png" alt="" class="img-header" />
        </div>
        <p class="title">
          Fitur dan Tarif <br />
          Rekening Peserta Emas Digital (RPED)
        </p>
        <div class="content">
          <table class="table table-bordered">
            <thead class="thead-light">
              <tr>
                <th colspan="2">Fitur Produk</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Tipe Produk</td>
                <td>Tabungan</td>
              </tr>
              <tr>
                <td>Mata Uang</td>
                <td>IDR</td>
              </tr>
              <tr>
                <td>Media Pencatatan</td>
                <td><i>e-stattment</i></td>
              </tr>
              <tr>
                <td>Fasilitas ATM</td>
                <td>Tidak Ada</td>
              </tr>
              <tr>
                <td>Fasilitas Mobile Banking</td>
                <td>Menu View Saja</td>
              </tr>
            </tbody>
            <thead class="thead-light">
              <tr>
                <th colspan="2">Tarif Produk</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Setoran Awal</td>
                <td>Bebas</td>
              </tr>
              <tr>
                <td>Setoran Selanjutnya</td>
                <td>Bebas</td>
              </tr>
              <tr>
                <td>Saldo Minimum</td>
                <td>Tidak Ada</td>
              </tr>
              <tr>
                <td>Biaya Administrasi Rekening</td>
                <td>Tidak Ada</td>
              </tr>
              <tr>
                <td>Denda Saldo Minimum</td>
                <td>Tidak Ada</td>
              </tr>
              <tr>
                <td>Biaya Tutup Rekening</td>
                <td>Tidak Ada</td>
              </tr>
            </tbody>
          </table>
          <form>
            <div class="form-group">
              <!-- <label>Saya sudah membaca dan memahami</label>
                      <input type="checkbox" checked required> -->
            </div>
          </form>
        </div>
        <p class="title " style="margin-top:30px">
          Syarat dan Ketentuan <br />
          Rekening Peserta Emas Digital (RPED)
        </p>
        <div class="content">
          <ol>
            <li class="menu">
              Definisi:
              <ol type="a" class="sub-menu">
                <li><b>Nasbah</b> adalah nasabah Bank yang merupakan Peserta Pasar Fisik Emas Digital.</li>
                <li>
                  <b>Pasar Fisik Emas Digital</b> adalah pasar fisik emas teroganisir yang dilaksanakan menggunakan sarana elektronik yang difasilitasi oleh
                  Bursa Berjangka Jakarta untuk jual atau beli emas digital yang catatan kepemilikan emasnya dilakukan secara digital.
                </li>
                <li><b>Peserta Pasar Fisik Emas Digital </b> adalah pihak yang bertindak selaku penjual dan/atau pembeli emas di Bursa Berjangka Jakarta.</li>
                <li>
                  <b>Perantara Perdagangan</b> adalah pihak yang telah memperoleh persetujuan dari Kepala Bappebti untuk menyalurkan transaksi jual atau beli
                  emas atas perintah Peserta Pasar Fisik Emas Digital ke Pasar Fisik Emas Digital.
                </li>
                <li>
                  <b>Rekening Peserta Emas Digital (RPED) </b> adalah rekening terpisah yang dibuka di Bank atas nama Nasabah melalui Perantara Perdagangan dan
                  hanya digunakan untuk memfasilitasi transaksi jual beli di Pasar Fisik Emas Digital.
                </li>
              </ol>
            </li>
            <li class="menu">
              Nasabah dengan ini memberikan kuasa kepada Bank untuk melakukan pembukaan RPED sesuai instruksi Nasabah melalui platform JFXGold.
            </li>
            <li class="menu">
              Nasabah dengan ini memberikan kuasa kepada Bank untuk melakukan pendebetan atau pengkreditan RPED sesuai instruksi nasabah melalui platform
              JFXGold dalam transaksi jual beli emas digital.
            </li>
            <li class="menu">
              Nasabah dengan ini memberikan kuasa kepada Bank untuk melakukan penutupan RPED sesuai instruksi Nasabah melalui platform JFXGold.
            </li>
            <!-- <li class="menu">
              Jika Nasabah hendak menyampaikan keluhan/pengaduan terkait RPED, Nasabah wajib menyampaikan keluhan atau pengaduan tersebut ke Perantara
              Perdagangan.
            </li>
            <li class="menu">
              Nasabah telah mengetahui dan memahami segala konsekuensi yang mungkin timbul sehubungan dengan pembukaan RPED, perubahan bunga, termasuk manfaat,
              risiko, biaya-biaya yang dibebankan, yang ketentuannya dapat berubah sewaktu-waktu berdasarkan kebijakan Bank.
            </li> -->
          </ol>
        </div>
        <div class="footer">
          <p></p>
          <p>page 1</p>
        </div>
      </div>
    </div>
    <div class="wrap-document">
      <div class="page">
        <div class="top">
          <img src="@/assets/iconImage/bagi.png" alt="" class="img-header" />
        </div>
        <div class="content">
          <ol start="5">
            <li class="menu">
              Jika Nasabah hendak menyampaikan keluhan/pengaduan terkait RPED, Nasabah wajib menyampaikan keluhan atau pengaduan tersebut ke Perantara
              Perdagangan.
            </li>
            <li class="menu">
              Nasabah telah mengetahui dan memahami segala konsekuensi yang mungkin timbul sehubungan dengan pembukaan RPED, perubahan bunga, termasuk manfaat,
              risiko, biaya-biaya yang dibebankan, yang ketentuannya dapat berubah sewaktu-waktu berdasarkan kebijakan Bank.
            </li>
          </ol>
        </div>
        <div class="footer">
          <p></p>
          <p>page 2</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fullName: String,
    dataPrint: Object,
  },
  data() {
    return {
      currentDate: "",
    };
  },
  mounted() {
    this.currentDate = new Date();
  },
};
</script>

<style scoped>
label {
  width: 100px;
}
.page {
  padding: 1cm;
  /* border: 5px red solid; */
  height: 257mm;
  /* outline: 2cm #FFFFFF solid; */
}

.format-text {
  text-transform: capitalize;
}

.format-text::first-letter,
.format-text::first-line {
  text-transform: capitalize;
}

.wrap-document {
  /* width: 210mm; */
  min-height: 297mm;
  padding: 10mm;
  margin: 0 auto;
  /* border: 1px #D3D3D3 solid; */
  border-radius: 5px;
  background: white;
  /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
  position: relative;
}

.tanda-tangan {
  position: relative;
  width: 75%;
  text-align: center;
  left: 13%;
}

.sub-menu {
  margin-left: 10px;
  margin-bottom: 5px;
  font-weight: normal;
}

.top {
  text-align: right;
  border-bottom: 1px solid #c0c0c0;
  margin-bottom: 10px;
}

.img-header {
  height: 45px;
  border-left: 1px solid #c0c0c0;
  padding: 5px 0 5px 5px;
}

.header {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  margin-bottom: 25px;
}

.nomor {
  font-weight: bold;
}

.lampiran p {
  margin: 0;
  text-align: right;
}

.title {
  font-weight: bold;
  text-align: center;
  margin: 0 auto 30px;
  font-size: 14px;
}

.content {
  font-size: 12px;
  text-align: justify;
}

.sub-content {
  font-weight: 700;
}

form {
  margin: 20px 0;
  text-align: right;
  font-weight: 700;
}

label {
  margin-right: 15px;
}

.penutup {
  text-align: center;
  font-size: 12px;
}

.penutup p {
  margin: 0;
}

.resiko {
  font-weight: 700;
}

.persetujuan {
  /* width: 60%; */
  font-size: 12px;
  margin: 30px 0 90px;
  display: flex;
  justify-content: space-between;
}

.persetujuan p {
  text-align: center;
  margin-bottom: 0;
}

.persetujuan div form {
  margin: 0;
  font-weight: normal;
}

.tanggal {
  margin-left: auto;
  margin-bottom: 10px !important;
}

.jabatan {
  margin-bottom: 70px !important;
}

.pt-abi {
  display: block !important;
  margin: 20px auto;
  width: 50%;
}

.pt-abi p {
  width: auto !important;
}

.footer {
  display: flex;
  font-size: 10px;
  justify-content: space-between;
  position: absolute;
  width: 80%;
  bottom: 10mm;
  border-top: solid 2px #c0c0c0;
}

.table td,
.table th {
  padding: 0.35rem;
}

@page {
  size: A4;
  margin: 0;
}
</style>
